import { render, staticRenderFns } from "./serverDiscuss.vue?vue&type=template&id=8fa22b9a&"
import script from "./serverDiscuss.vue?vue&type=script&lang=ts&"
export * from "./serverDiscuss.vue?vue&type=script&lang=ts&"
import style0 from "./serverDiscuss.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports